// extracted by mini-css-extract-plugin
export default {"priceListUER":"PriceListUER_priceListUER__2XGsT","wrapperFilesSelector":"PriceListUER_wrapperFilesSelector__OLCH5"};